import { TableHead } from "@mui/material";
import { flexRender } from "@tanstack/react-table";
import React from "react";
import { useCoreTableContext } from "../CoreTable";
import CoreTableCell from "./CoreTableCell";
import CoreTableHeader from "./CoreTableHeader";
// import PropTypes from 'prop-types'

const CoreTableHead = () => {
  const { table } = useCoreTableContext();

  return (
    <TableHead>
      {table.getHeaderGroups().map((headerGroup) => (
        <CoreTableHeader key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            return (
              <CoreTableCell
                key={header.id}
                align={header.column.columnDef.align}
                {...{
                  colSpan: header.colSpan,
                  className: header.column.columnDef.className,
                  style: {
                    width: header.getSize(),
                    fontSize: "12px",
                  },
                }}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
              </CoreTableCell>
            );
          })}
        </CoreTableHeader>
      ))}
    </TableHead>
  );
};

//CoreTableHead.defaultProps = {}

//CoreTableHead.propTypes = {}

export default React.memo(CoreTableHead);
